import { RequestQuery } from '@/buyers/_gen/gql'
import Action from '@/gf/components/Action'
import useToggle from '@/gf/hooks/useToggle'
import useGqlClient from '@/buyers/hooks/useGqlClient'
import EditPartCostCodeModal from '@/buyers/components/EditCostCodeModal'

const CostCodeAction = ({
  rfqPart,
}: {
  rfqPart: RequestQuery['requestForQuotesSearch']['requestForQuotes'][number]['partRequests'][number]
}) => {
  const [open, toggle] = useToggle()
  const client = useGqlClient()
  return (
    <>
      <EditPartCostCodeModal
        open={open}
        onClose={toggle.off}
        part={{ partNumber: rfqPart.mpn ?? '', description: rfqPart.description ?? '' }}
        costCodeId={rfqPart.costCode?.id ?? null}
        partRequestId={rfqPart.id}
        onSuccess={() => client.reFetchObservableQueries()}
      />

      {rfqPart.costCode ? (
        <Action.T className="text-sm" onClick={toggle.on}>
          {rfqPart.costCode.code}
        </Action.T>
      ) : (
        <Action.T className="text-sm" onClick={toggle.on}>
          Add
        </Action.T>
      )}
    </>
  )
}

export default CostCodeAction
